import PropTypes from 'prop-types'
import { useEffect } from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'


const decorators = [
  memoized,
]

function ResizeWatcher(props) {
  function handleResize() {
    const { onChange } = props

    onChange()
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return null
}

ResizeWatcher.propTypes = {
  onChange: PropTypes.func.isRequired,
}

ResizeWatcher = chainDecorators(decorators, ResizeWatcher)

export default ResizeWatcher
